// extracted by mini-css-extract-plugin
module.exports = {"title":"Cafe_title__25zK1","image":"Cafe_image__1q0W-"};